import styled from "styled-components";

export const Container = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 10px;
`;

export const Poster = styled.div`
  display: flex;
  margin: 5px;
  img {
    border-radius: 7px;
    width: 250px;
  }
`;
